<template>
  <v-container class="text-center">
    <!-- <v-row align="center" justify="center"> -->
      <!-- <v-col cols="12" sm="8" md="4"> -->
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card flat contain>
          <v-img class="ma-2" src="../assets/jachal.me.png"></v-img>
        </v-card>
      </v-flex>
    </v-layout>
        <!-- <v-card flat contain>
          <v-img src="../assets/jachal.me.png"></v-img>
        </v-card> -->
      <!-- </v-col> -->
    <!-- </v-row> -->
  </v-container>
</template>

<script>
export default {
  name: "about"
}
</script>

<style scoped>

</style>
